import { FooterMaximized } from "components/footerfull";
import Header from "components/headerfull";
import { Link, useSearchParams } from "react-router-dom";
import "../styles/404.css";

export default function FourOfour(){
    const [searchParams, setSearchParams] = useSearchParams()

    const {statusCode,message, description} = {
        statusCode: searchParams.get('statusCode') ?? 404,
        message: searchParams.get('message') ?? "Page introuvable.",
        description: searchParams.get('description') ? searchParams.get('description') :  !searchParams.get('statusCode')  ? <p className="main-p font-dm-sans">L'URL recherché n'existe pas sur ce site.<br/><Link to="/" >Retourner à la page d'accueil.</Link></p> :null
    }
    return <>
        <div className="wrapper-404">
            <Header type="default" />
            <div className="w-full bg-[#f4f4f5] grow flex flex-row items-center justify-center">
                <div className="main-container fancy">
                    <span className="title-sub bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500">{statusCode}</span>
                    <div className="flex flex-col items-start justify-between gap-[30px]">
                        <h1 className="main-title">{message}</h1>
                        {description}
                    </div>
                </div>
            </div>
            <FooterMaximized />
        </div>
    </>;
};